import { render, staticRenderFns } from "./ModalTnC.vue?vue&type=template&id=eebf3ae6&scoped=true"
import script from "./ModalTnC.vue?vue&type=script&lang=js"
export * from "./ModalTnC.vue?vue&type=script&lang=js"
import style0 from "./ModalTnC.vue?vue&type=style&index=0&id=eebf3ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebf3ae6",
  null
  
)

export default component.exports